/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import "../../../assets/css/HTML.scss"
import { ALIGN, HTMLContent, ILandingSection, IScreenPosition, TEXT_ALIGN } from "../../../data/interfaces"
import DataContentEditor from "../landing-edit/editors/data-content-editor"
import RandomContentPrimitive from "../primitive/RandomContentPrimitive"
import Dummy from "./Dummy"

/* Protopia Ecosystem component */
export interface IHTMLProps {
   section: ILandingSection
   data: HTMLContent 
}
const RandomContent = ({data, ...props}: IHTMLProps): JSX.Element => {
    const {position}        = usePosition(data)
    const [marginLeft]      = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]     = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]       = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]    = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0") 
    const [height, setHeight]       = useState<string>(getCssDemention( position.height || data.height, "fit-content" ))
    const [width]                   = useState<string>(getCssDemention( position.width || data.width, "100%" ))
    const [padding]                 = useState<string>(getCssDemention( data.padding, "0" ))
    const [borderRound]             = useState<string>(getCssDemention( data.incutBorder?.borderRound?.border, "0" ))
    
    useEffect(() => {
        addCSSClass(
            `landing-random-content-${data.id}`,
            `.landing-random-content-${data.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                text-align:${ TEXT_ALIGN[ data.text_align || ALIGN.START] }; 
                width: 100%;
                max-height: ${ height };
                height: ${ height }; 
                padding: ${padding};
                z-index:1; 
            }`
        ) 
        return () => {
            removeCSSClass(`landing-random-content-${data.id}`)
        }
    },[ data, height, padding, borderRound ])
  
    return <div 
        className={`pe-random-content-container landing-content-container`} 
        style={{ backgroundColor: data.background || "transparent" }}
        data-type={data.type} 
        data-content-id={data.id}
    >
        {
            !!data.data.length
                ?
                <> 
                        <div className={ `landing-random-content-${data.id} ${data.className}`} style={ data.style } >
                            <RandomContentPrimitive
                                primitive={{
                                    ...data,
                                    position: {} as IScreenPosition
                                }}
                                section={props.section}
                            />
                        </div>  
                    <DataContentEditor data={data} section={props.section}  />
                </>
                :
                <Dummy {...{ 
                    ...{
                        data: {
                            ...data,
                            className: ` ${data.className} landing-html-${data.id} `
                        },
                    }, 
                    ...props 
                }} />
        }
        
    </div>
}
export default RandomContent
 